import { trackClick as trackClickHandler } from '@bumble/seo-events-tracking';
import { IncomingMessage } from 'http';
import { sendData } from 'lib/api/send-data';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';

export type TrackClickProps = {
    req: IncomingMessage;
    lang: SupportedLanguage;
};

export const trackClick = ({ req, lang }: TrackClickProps) =>
    trackClickHandler({
        headers: req.headers,
        url: req.url,
        lang,
        eventName: 'SEO_CLICK',
        eventRoute: '/ins-and-outs',
        eventDomain: 'badoo.com',
        sendEventHandler: sendData,
    });
